// generic error page that individual pages can render when a user does not have the right(s) to access the page
import { PaxErrorPage, useTranslation } from "@ncino/pax-ui";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { ErrorComponentProps } from "@/shared/errors";

export function UnauthorizedPage({ reset }: ErrorComponentProps) {
  const router = useRouter();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <PaxErrorPage
      header={t("unauthorized.header")}
      subtext=""
      actionLabel={t("unauthorized.actionLabel")}
      onAction={() => {
        router.invalidate();
        reset?.();
        navigate({ to: "/" });
      }}
    />
  );
}
